
export class TemplateDeliveryPath {

  constructor(
    public code: string
  ) {}

}

